import { isCanvasPreviewImageId } from '@/pages/ipe/workbench/utils/templateListUtils';

/** 套图模板列表：指定轮播图对应的印花区域（键与图片 ID 不一致时做单图兜底） */
export function resolveStampAreasLookupImageId(imageId, stampAreas, images) {
  if (!imageId || !stampAreas || typeof stampAreas !== 'object') return imageId;
  if (stampAreas[imageId]) return imageId;

  if (isCanvasPreviewImageId(imageId)) {
    const slideId = String(imageId).replace(/__canvas_preview__$/, '');
    if (slideId && stampAreas[slideId]) return slideId;
  }

  const imageIds = (images || []).map((img) => (img && typeof img === 'object' ? img.id : img)).filter(Boolean);
  if (imageIds.includes(imageId)) return imageId;

  const keys = Object.keys(stampAreas);
  const fb = keys.find((k) => {
    const v = stampAreas[k];
    if (Array.isArray(v)) return v.length > 0;
    return v && typeof v === 'object' && Object.keys(v).length > 0;
  });
  if (fb && (imageIds.length <= 1 || imageIds.includes(fb))) return fb;
  return imageId;
}

/** 读取指定轮播图的 stampAreas 列表与图片尺寸元数据 */
export function pickImageTemplateStampAreasForImage(template, imageId) {
  const td = template?.templateData;
  if (!td || typeof td.stampAreas !== 'object' || !imageId) {
    return { stampList: [], refW: 0, refH: 0 };
  }
  const images = Array.isArray(td.images) ? td.images : [];
  const lookupId = resolveStampAreasLookupImageId(imageId, td.stampAreas, images);
  const imgMeta = images.find((img) => {
    const id = img && typeof img === 'object' ? img.id : img;
    return id != null && String(id) === String(lookupId);
  });
  const refW = imgMeta && typeof imgMeta === 'object' ? Number(imgMeta.width) || 0 : 0;
  const refH = imgMeta && typeof imgMeta === 'object' ? Number(imgMeta.height) || 0 : 0;

  let raw = td.stampAreas[lookupId];
  if (!raw || (Array.isArray(raw) && raw.length === 0)) {
    const keys = Object.keys(td.stampAreas);
    const fb = keys.find((k) => {
      const v = td.stampAreas[k];
      if (Array.isArray(v)) return v.length > 0;
      return v && typeof v === 'object' && Object.keys(v).length > 0;
    });
    if (images.length <= 1 && fb) raw = td.stampAreas[fb];
  }
  let list = [];
  if (Array.isArray(raw)) list = raw;
  else if (raw && typeof raw === 'object') list = Object.values(raw);
  list = list.filter((s) => s && typeof s === 'object');
  return { stampList: list, refW, refH };
}

/** 解析预览主图 imageId（去掉 canvas_preview 后缀以便查 stampAreas） */
export function resolveTemplatePreviewImageId(template) {
  let imageId = template?.previewImageId;
  if (!imageId) {
    const images = template?.templateData?.images;
    if (Array.isArray(images) && images.length > 0) {
      const first = images[0];
      imageId = typeof first === 'string' ? first : first?.id;
    }
  }
  if (imageId && isCanvasPreviewImageId(imageId)) {
    const slideId = String(imageId).replace(/__canvas_preview__$/, '');
    if (slideId) return slideId;
  }
  return imageId || null;
}

/** 构建列表/弹窗印花叠层所需 layout */
export function buildStampOverlayLayout(template, { refW = 0, refH = 0, measured } = {}) {
  const td = template?.templateData && typeof template.templateData === 'object' ? template.templateData : {};
  const workspaceWidth = Number(td.workspaceWidth) || 0;
  const workspaceHeight = Number(td.workspaceHeight) || 0;
  // 优先图元数据 / 实测尺寸；兜底用工作区尺寸，避免默认 900×1200 导致比例与叠层错位
  const imageW = refW || measured?.width || workspaceWidth || 900;
  const imageH = refH || measured?.height || workspaceHeight || 1200;
  return {
    workspaceWidth: workspaceWidth || imageW,
    workspaceHeight: workspaceHeight || imageH,
    imageWidth: imageW,
    imageHeight: imageH,
  };
}
